import React from "react";
import NavbarContainer from "./NavbarContainer";

export default props => <NavbarContainer {...props} />;



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js